import { render, staticRenderFns } from "./RejectionEvents.vue?vue&type=template&id=ba8c617e&lang=pug&"
import script from "./RejectionEvents.vue?vue&type=script&lang=js&"
export * from "./RejectionEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports